export enum PayoutRequisitesAutomationType {
  AMobile = 'amobile',
}
